import React, { useContext, useEffect, useState } from 'react';
import { Layout, Menu, Col, Row, Card, App } from 'antd';
import { Link } from 'react-router-dom';
import { AimOutlined, BookOutlined, BuildOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { AppContext } from '../App';
import { logout } from '../models/serverApi';

const { Header, Content, Footer, Sider } = Layout;
const DashboardLayout: React.FC<{ children: React.ReactNode; }> = props => {
    const children = props.children ? props.children : [];
    const [menuCollapsed, setMenuCollapsed] = useState(false);
    const context = useContext(AppContext);
    const { modal, message } = App.useApp();

    /**
     * Confirm, sign out, then land on the login page.
     *
     * The menu item used to be a plain link to /Identity/Account/Logout. That
     * page only signs out on POST, so following the link merely rendered a
     * second button to press - two clicks and an intermediate screen for what
     * is one decision.
     *
     * The redirect is a full page load rather than a react-router navigation:
     * the SPA holds patient data in memory, and after signing out none of it
     * should still be in the tab.
     */
    const confirmLogout = () => {
        modal.confirm({
            title: "Αποσύνδεση",
            content: "Είστε σίγουροι ότι θέλετε να αποσυνδεθείτε;",
            okText: "Αποσύνδεση",
            cancelText: "Άκυρο",
            okButtonProps: { danger: true },
            onOk: async () => {
                if (await logout()) {
                    window.location.assign("/Identity/Account/Login");
                }
                else {
                    // Staying put is the safe failure: redirecting on a failed
                    // sign-out would show a login page while the session cookie
                    // is still valid.
                    message.error("Η αποσύνδεση απέτυχε. Προσπαθήστε ξανά.");
                }
            }
        });
    };


    return <Layout className="dashboard-layout">
        <Header>
            <Row>
                <Col span={24}>
                    <Link className="logo" to="/"><img src="/BIOSTATS-LOGO-TRASPARENT-5800-1.png" style={{ maxHeight: "55px" }} /></Link>
                    <Menu theme="light" style={{ display: "flex", justifyContent: "flex-end" }} mode="horizontal" items={
                        [
                            {
                                key: "home",
                                label: <Link to="/dashboard">Αρχική</Link>
                            },
                            ...(context[0]?.user?.admin ? [{
                                key: "audit",
                                label: <Link to="/audit">Audit Trail</Link>
                            }] : []),
                            {
                                key: "inquiries",
                                label: <Link to="/inquiries"><QuestionCircleOutlined /> Ερωτήσεις</Link>
                            },
                            {
                                key: "logout",
                                label: "Αποσύνδεση",
                                onClick: confirmLogout
                            }, {
                                key: "user",
                                label: context[0]?.user?.email
                            }]
                    }>
                    </Menu>
                </Col>
            </Row>
        </Header>
        <Content>
            <Layout>
                <Content>
                    <div className="dashboard-layout-content">{children}</div>
                </Content>
            </Layout>
        </Content>
    </Layout>;
}

export default DashboardLayout;